import { createContext } from 'react';

export const BrowserContext = createContext(null);
